import api from 'services/api'
import {
  GET_DASHBOARD_USERS,
  GET_DASHBOARD_VISITORS,
  GET_DASHBOARD_INVOICES,
  GET_DASHBOARD_ACTIVITIES,
  GET_DASHBOARD_NOTIFICATIONS,
  GET_DASHBOARD_SOCIETIES_COUNT,
  GET_CITY_SOCIESTIES,
  GET_AGE_GROUP,
  GET_DASHBOARD_COUNTS,
} from '../endpoints'

export const getDashboardCounters = async () => await api.get(GET_DASHBOARD_COUNTS)
export const getDashboardUsers = async () => await api.get(GET_DASHBOARD_USERS)
export const getDashboardVisitors = async (params = {}) => {
  return await api.get(GET_DASHBOARD_VISITORS, { params })
}
//export const getDashboardVisitors = async () => await api.get(GET_DASHBOARD_VISITORS)
export const getDashboardInvoices = async (params = {}) => {
  return await api.get(GET_DASHBOARD_INVOICES, { params })
}
//export const getDashboardInvoices = async () => await api.get(GET_DASHBOARD_INVOICES)
//export const getDashboardActivities = async () => await api.get(GET_DASHBOARD_ACTIVITIES)
export const getDashboardActivities = async (params = {}) => {
  return await api.get(GET_DASHBOARD_ACTIVITIES, { params })
}
export const getDashboardNotifications = async () => await api.get(GET_DASHBOARD_NOTIFICATIONS)
export const getDashboardSocietiesCount = async () => await api.get(GET_DASHBOARD_SOCIETIES_COUNT)
export const getCitySocieties = async () => await api.get(GET_CITY_SOCIESTIES)
export const getAgeGroup = async () => await api.get(GET_AGE_GROUP)

